module.exports = __webpack_public_path__ + "static/img/Massimo-D_Ambrosio.041bca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Massimo-D_Ambrosio.jpg
// module id = sydV
// module chunks = 0